<div
  class="app-signature-field relative col-12 full-height mat-{{ color }}"
  [class.app-signature-field--disabled]="disabled"
  (click)="onClick($event)"
>
  <div class="app-sign-field-header absolute col-12">
    <ng-content select="[header]"></ng-content>
  </div>

  <div
    class="app-sign-field-content col-12 full-height absolute left-0 top-0 overflow-hidden"
    (click)="clickContent.emit()"
  >
    <ng-content></ng-content>

    <!-- TODO: uncomment if re-signing becomes a feature -->
    <!-- <div
    *ngIf="!disabled && signed"
    class="absolute right-0 bottom-0 flex items-center font-small bold px1"
    >
    <lib-icon icon="history_edu" class="mr1"></lib-icon>Klikněte pro opakování podpisu
  </div> -->
  </div>

  <div class="app-sign-field-footer absolute">
    <ng-content select="[footer]"></ng-content>
  </div>

  <!-- <div class="app-sign-field-cover col-12 full-height absolute left-0 top-0"></div> -->
</div>
